const c = "조회 결과가 없습니다";
let i = null;
function d(n) {
  i = n;
}
function p() {
  return i && i() || c;
}
function s(n) {
  return n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function f(n) {
  return n.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[－ー−]/g, "-").replace(/，/g, ",").replace(/．/g, ".");
}
function l(n, t = !0) {
  n = f(n);
  const e = t && /^\s*-/.test(n), r = n.split(".", 1)[0].replace(/[^\d]/g, "");
  return r ? (e ? "-" : "") + r.replace(/^0+(?=\d)/, "") : e ? "-" : "";
}
function y(n) {
  var r;
  if (n == null || n === "") return "";
  const t = typeof n == "number" ? String(n) : n.trim(), e = /^(-?)(\d+)(\.\d+)?$/.exec(t);
  return e ? e[1] + s(e[2]) + ((r = e[3]) != null ? r : "") : t;
}
function C(n) {
  const t = l(n);
  if (t === "" || t === "-") return;
  const e = Number(t);
  return Number.isFinite(e) ? e : void 0;
}
function S(n) {
  return n.toLocaleString("ja-JP");
}
function T(n) {
  return n == null ? "—" : n.toLocaleString("ja-JP");
}
function E(n) {
  return n == null ? "" : n.toLocaleString("ja-JP");
}
const m = ["JPY", "KRW", "VND", "CLP", "ISK", "UGX", "PYG"];
function g(n) {
  return n && m.indexOf(n.toUpperCase()) >= 0 ? 0 : n ? 2 : 0;
}
function o(n, t) {
  if (n == null) return "-";
  const e = g(t);
  return n.toLocaleString("ja-JP", { style: "decimal", minimumFractionDigits: e, maximumFractionDigits: e });
}
let u = null;
function P(n) {
  u = n || null;
}
function b() {
  return u;
}
function a(n, t) {
  var r;
  if (!n) return !0;
  const e = t && "base" in t ? t.base : u;
  return ((r = t == null ? void 0 : t.hideBaseUnit) != null ? r : !0) && !!e && e.toUpperCase() === n.toUpperCase();
}
function D(n, t) {
  return a(n, t) ? "" : n;
}
function h(n, t) {
  return a(n, t) ? "" : `(${n})`;
}
function N(n, t, e) {
  const r = o(n, t);
  return !a(t, e) && n != null ? `${r} ${t}` : r;
}
function U(n) {
  return o(n);
}
function x(n) {
  return n ? n.slice(0, 16).replace("T", " ") : "—";
}
export {
  c as A,
  l as a,
  C as b,
  p as c,
  g as d,
  D as e,
  y as f,
  x as g,
  o as h,
  N as i,
  S as j,
  E as k,
  T as l,
  U as m,
  b as n,
  h as o,
  P as p,
  d as s,
  f as t
};
